import { isWorkWeChat,isWeChat,AppScreen,handleMediaDevices  } from "../../common/commonHelper" 
import { AppEnv } from "../../store/index"
import store from "../../store/store"
import { getJsApiConfig } from "../../apis/httpHelper";

export default function initApp() {
    let workWeiXinEnv = isWorkWeChat();
    let weixinEnv = isWeChat();
    
    if(weixinEnv && !workWeiXinEnv){
        store.commit("SetAppEnv",AppEnv.WeChat);
    }
    else if(workWeiXinEnv){
        store.commit("SetAppEnv",AppEnv.WorkWeChat);
    }
    
    if(workWeiXinEnv || weixinEnv){
        getJsApiConfig(location.href.split('#')[0]).then(x=> {
            let result = x.Result;
            window.wx.config({
                beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: result.AppId, // 必填，企业微信的corpID
                timestamp: result.Timestamp, // 必填，生成签名的时间戳
                nonceStr: result.NonceStr, // 必填，生成签名的随机串
                signature: result.Signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
                jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
            });
        })
    }
    let screen = new AppScreen();
    store.commit("SetScreenInfo",{ 
        screenSize: screen.screenSize, 
        width:screen.width,
        height:screen.height 
    });
    store.commit("SetSupportCameraState", handleMediaDevices());
}
